//Created by wangshuyi on 07/03/2018.

'use strict';

//plugin
import { erp, h5Api } from './ajax/dol-erp';
import dotNetUtil from './ajax/dol-dotNet-util';
import goPath from './util/goPath';
import auth from "./auth/Dol-auth";
import directive from './auth/dol-directive'
//component
import DolList from './list/dol-list.vue';
import DolFormModel from './form/dol-form-model.js';
import DolFormItem from './form/dol-form-item';
import DolMultipleInput from './form/dol-multiple-input';
import DolSelect from './form/dol-select';
import DolSelectModal from './form/dol-select-modal';
import DolTreeSelect from './form/dol-tree-select';
import DolTags from './form/dol-tags';
import DolTree from './tree/dol-tree.vue';
import DolUpload from './upload/dol-upload';
import DolSwitch from './form/dol-switch'
import DolImageListPreview from './upload/dol-image-list-preview';
import DolImport from './upload/dol-import';
import DolImg from './upload/dol-upload-img';
import DolImgList from './upload/dol-upload-img-list';
import DolMonth from './time/dol-month.vue';
import DolDate from './time/dol-date.vue';
import DolTime from './time/dol-time.vue';
import DolClock from './time/dol-clock.vue';
import DolButton from './button/dol-button';
import DolBreadcrumb from './breadcrumb/dol-breadcrumb';
import DolDrawer from './drawer/dol-drawer';
import DolCard from './card/dol-card.vue';
import DolDict from './dict/dol-dict.vue';
import dict from './dict/Dol-dict';
import DolI18n from './Dol-i18n';
export default {
  install(Vue) {
    Vue.prototype.$erp = erp;
    Vue.prototype.$dict = dict;
    Vue.prototype.$h5Api = h5Api;
    Vue.prototype.$dotNetUtil = dotNetUtil;
    Vue.prototype.$dt = DolI18n;
    Vue.prototype.$goPath = goPath;
    Vue.prototype.$auth = auth;

    Vue.component(DolList.name, DolList);
    Vue.component(DolFormModel.name, DolFormModel);
    Vue.component(DolFormItem.name, DolFormItem);
    Vue.component(DolMultipleInput.name, DolMultipleInput);
    Vue.component(DolSelect.name, DolSelect);
    Vue.component(DolSelectModal.name, DolSelectModal);
    Vue.component(DolTreeSelect.name, DolTreeSelect);
    Vue.component(DolTags.name, DolTags);
    Vue.component(DolTree.name, DolTree);
    Vue.component(DolMonth.name, DolMonth);
    Vue.component(DolDate.name, DolDate);
    Vue.component(DolTime.name, DolTime);
    Vue.component(DolClock.name, DolClock);
    Vue.component(DolSwitch.name, DolSwitch);
    Vue.component(DolUpload.name, DolUpload);
    Vue.component(DolImageListPreview.name, DolImageListPreview);
    Vue.component(DolImport.name, DolImport);
    Vue.component(DolImgList.name, DolImgList);
    Vue.component(DolImg.name, DolImg);
    Vue.component(DolButton.name, DolButton);
    Vue.component(DolBreadcrumb.name, DolBreadcrumb);
    Vue.component(DolDrawer.name, DolDrawer);
    Vue.component(DolCard.name, DolCard);
    Vue.component(DolDict.name, DolDict);

    directive.forEach(d => Vue.directive(d.name, d.options));
  }
};
